import { Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import CustomBreadcrumbs from 'src/legacy/components/custom-breadcrumbs';
import Iconify from 'src/legacy/components/iconify';
import { useLocales } from 'src/legacy/locales';
import { PATH_DASHBOARD } from 'src/legacy/routes/paths';

import {
  defaultTabs,
  usePlacementListNavigatorContext,
} from './PlacementListNavigatorContext';

export const Breadcrumbs = () => {
  const { currentTab } = usePlacementListNavigatorContext();
  const { translate } = useLocales();

  const pageName =
    defaultTabs.find(({ value }) => value === currentTab)?.label || 'profile';

  return (
    <CustomBreadcrumbs
      action={
        <Button
          component={RouterLink}
          startIcon={<Iconify icon="eva:plus-fill" />}
          to={PATH_DASHBOARD.placement.new}
          variant="contained"
        >
          {`${translate('new')} ${translate('placement')}`}
        </Button>
      }
      heading={`${translate('placements')}`}
      links={[
        { href: PATH_DASHBOARD.root, name: `${translate('dashboard')}` },
        {
          href: PATH_DASHBOARD.placement.root,
          name: `${translate('placements')}`,
        },
        { name: `${translate(pageName)}` },
      ]}
    />
  );
};
